import AppBootstrap from './AppBootstrap';

export default AppBootstrap;
